/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMemberInviteDto } from '../../models/backend-member-invite-dto';
import { BackendMemberInviteRequestDto } from '../../models/backend-member-invite-request-dto';

export interface AccessProjectsMembersInviteCreate$Params {
  project_id: number;
  body: BackendMemberInviteRequestDto;
}

export function accessProjectsMembersInviteCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsMembersInviteCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMemberInviteDto>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsMembersInviteCreate.PATH, 'post');
  if (params) {
    rb.path('project_id', params.project_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMemberInviteDto>;
    }),
  );
}

accessProjectsMembersInviteCreate.PATH = '/api/access/projects/{project_id}/members/invite/';
